import {
  SUMMARY_ATTEMPT,
  SUMMARY__SUCCESS,
  SUMMARY_FAILED,
} from "../types/summaryByUserTypes";

const INITIAL_STATE = {
  loading: false,
  item: {},
  error: "",
};

function summaryByUser(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SUMMARY_ATTEMPT:
      return {
        ...state,
        loading: true,
      };

    case SUMMARY__SUCCESS:
      return {
        ...state,
        loading: false,
        item: action.item,
        error: "",
      };

    case SUMMARY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.errsor,
        item: {},
      };

    default:
      return state;
  }
}
export default summaryByUser;
